const animateWhenInViewport = ( $ ) => {

	const isElementInViewport = (element) => {

		// Get the scroll position of the page.
		let viewportTop = $(window).scrollTop();
		let viewportBottom = viewportTop + $(window).height();

		// Get position of the elements
		let elementTop = $(element).offset().top;
		let elementBottom = elementTop + $(element).height();

		if (elementTop <= viewportBottom && elementBottom >= viewportTop) {
			return true;
		}
	}

	const checkAnimation = () => {

		const elements = $(".animate-image, .animate-text");

		$(elements).each(function() {

			if (isElementInViewport(this)) {
				// Start the animation
				$(this).addClass("start");
			}
		})
	}


	$(window).load(function () {
		checkAnimation();
	});

	$(window).scroll(function () {
		checkAnimation();
	});
}

export default animateWhenInViewport;
